module.exports = __webpack_public_path__ + "fonts/Gilroy-MediumItalic.e50c6ab.woff";